"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAthenaQueries = exports.validateAthenaQuery = exports.areValidFinleyAthenaTables = exports.isFinleyAthenaTable = exports.extractTableNamesFromQuery = void 0;
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const construct_1 = require("../construct");
const utils = __importStar(require("../utils"));
/**
 * Note that this only focuses on read-only SQL queries, as these are
 * the only commands that Athena supports. Thus, only checking for
 * "from" and "join" and not "create table", "update", etc.
 */
const extractTableNamesFromQuery = (queryString) => {
    var _a;
    const tables = (_a = queryString.match(/(?<=(from|join)\s+)(\w+)/gim)) !== null && _a !== void 0 ? _a : [];
    if (!tables) {
        return [];
    }
    return lodash_1.default.uniq(tables);
};
exports.extractTableNamesFromQuery = extractTableNamesFromQuery;
const isFinleyAthenaTable = (tableName) => {
    return finley_types_1.DataLake.ALL_TABLE_PREFIXES.some((prefix) => tableName.startsWith(prefix));
};
exports.isFinleyAthenaTable = isFinleyAthenaTable;
/**
 * If needed, can pair with "artifact" controller "getAthenaTablesForOrganization"
 * to first fetch the proper valid tables
 */
const areValidFinleyAthenaTables = (params) => {
    const { inputTables, allowedFinleyTables } = params;
    const inputFinleyTables = inputTables.filter((table) => (0, exports.isFinleyAthenaTable)(table));
    const lowerAllowedFinleyTables = allowedFinleyTables.map((table) => table.toLowerCase());
    const unallowedTables = [];
    for (const table of inputFinleyTables) {
        if (!lowerAllowedFinleyTables.includes(table.toLowerCase())) {
            unallowedTables.push(table);
        }
    }
    if (unallowedTables.length > 0) {
        return { isValid: false, unallowedTables };
    }
    return { isValid: true };
};
exports.areValidFinleyAthenaTables = areValidFinleyAthenaTables;
const validateAthenaQuery = ({ query, bindings, variables, }) => {
    try {
        const errors = [];
        if (query === '') {
            errors.push('Athena query string is empty');
            return errors;
        }
        // checks for dup variables, pass variables to formula bindings, evaluate formula bindings,
        // attach binding to query
        const queryStringResult = (0, construct_1.constructSqlQueryString)({
            query,
            bindings,
            variables,
        });
        if (!queryStringResult.isValid) {
            return queryStringResult.errors;
        }
        // validate query syntax
        // TODO - find presto / trino parser that validate our athena query syntax sync
        // failed packages:
        //  - node-sql-parser (and several others that failed during initial selection)
        // validate query against forbidden keywords
        const res = common_1.datalake.athena.validateForbiddenSqlString(queryStringResult.queryString);
        variables.forEach(({ name: variableName }) => {
            if (variableName === '') {
                errors.push(`Athena query variable name is empty. Athena Query: ${query}`);
            }
        });
        if (!res.isValid) {
            errors.push(res.errorMessage);
        }
        return errors;
    }
    catch (err) {
        return utils.handleError({
            err,
            prefix: `Error during validateAthenaQuery. Athena Query: ${query}.`,
        });
    }
};
exports.validateAthenaQuery = validateAthenaQuery;
const validateAthenaQueries = (queries) => {
    const errors = [];
    const queryNameSet = new Set();
    const queryResultVariablesSet = new Set();
    queries.forEach((query) => {
        const { query: { queryString, name: queryName }, variables, bindings, columnNames, } = query;
        if (queryName === '') {
            errors.push(`Athena Query name is empty.`);
        }
        if (queryNameSet.has(queryName)) {
            errors.push(`Duplicate Athena query name detected: ${queryName}`);
        }
        else {
            queryNameSet.add(queryName);
        }
        if (!columnNames.length) {
            errors.push(`Athena Query ${queryName} column names have not been set.`);
        }
        columnNames.forEach((columnName) => {
            const queryResultVariable = `${queryName}.${columnName}`;
            if (queryResultVariablesSet.has(queryResultVariable)) {
                errors.push(`Detected duplicate Athena Query result variable ${queryResultVariable}.`);
            }
            else {
                queryResultVariablesSet.add(queryResultVariable);
            }
        });
        // validates variables, formula bindings, # of bindings, query syntax
        const queryErrors = (0, exports.validateAthenaQuery)({
            query: queryString,
            bindings,
            variables,
        });
        queryErrors.forEach((err) => errors.push(err));
    });
    return { errors, queryResultVariables: Array.from(queryResultVariablesSet) };
};
exports.validateAthenaQueries = validateAthenaQueries;
//# sourceMappingURL=athenaValidate.js.map